import { observable, isFunction, isPromise } from '../../../utils'

export default class TableRequest {
  constructor (props = {}) {
    const {
      pageSize = 10
    } = props

    this.state = observable({
      data: [],
      sortable: {},
      pagination: {
        currentPage: 1,
        total: 0,
        pageSize
      }
    })

    let requestHandlers = []

    this.request = () => {
      requestHandlers.forEach(handler => {
        const {
          currentPage,
          pageSize
        } = this.state.pagination

        const {
          sortable
        } = this.state

        const p = handler(currentPage, pageSize, sortable)

        if (isPromise(p)) {
          p.then(({ data, total }) => {
            this.state.data = data
            this.state.pagination.total = total
          })
        }
      })
    }

    this.onRequest = (requestHandler) => {
      if (isFunction(requestHandler)) {
        requestHandlers.push(requestHandler)
      }
    }

    this.refresh = () => {
      this.state.pagination.currentPage = 1

      this.request()
    }

    this.refreshCurrentPage = () => {
      this.request()
    }

    this.handleSortChange = (sortable) => {
      this.state.sortable = sortable

      this.request()
    }

    this.handleSizeChange = (pageSize) => {
      this.state.pagination.pageSize = pageSize

      this.refresh()
    }

    this.handleCurrentChange = (currentPage) => {
      this.state.pagination.currentPage = currentPage

      this.request()
    }
  }
}
